$(function(){
    if ($("section.info-app").length > 0){
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (window.innerWidth < 481){
            if (/android/i.test(userAgent)) {
                var hrefAndroid = $("section.info-app").find(".androidApp").attr("href");
                if ($("section.info-app").find(".androidApp").data("text")){
                    var textAndroid = $("section.info-app").find(".androidApp").data("text");
                    $("section.info-app").find("h2").before("<a class='btn btn-destacado btn-lg descargaApp-infoApp' href='"+hrefAndroid+"'>"+textAndroid+"</a>");
                    $("section.info-app").find(".iphoneApp").remove();
                }
            }
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                var hrefIphone = $("section.info-app").find(".iphoneApp").attr("href");
                if ($("section.info-app").find(".iphoneApp").data("text")){
                    var textIphone = $("section.info-app").find(".iphoneApp").data("text");
                    $("section.info-app").find("h2").before("<a class='btn btn-destacado btn-lg descargaApp-infoApp' href='"+hrefIphone+"'>"+textIphone+"</a>");
                    $("section.info-app").find(".androidApp").remove();
                }
            }
        }
    }
})